import { QueryClient } from "@tanstack/react-query";

const queryClient = new QueryClient({
	defaultOptions: { queries: { staleTime: 30_000, gcTime: 30_000 } },
});

export { queryClient };
